import { __assign, __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Skeleton from "@mui/material/Skeleton";
export var Image = function (_a) {
    var src = _a.src, alt = _a.alt, width = _a.width, height = _a.height, skeleton = _a.skeleton, rest = __rest(_a, ["src", "alt", "width", "height", "skeleton"]);
    var _b = React.useState(false), loaded = _b[0], setLoaded = _b[1];
    var handleLoad = function () { return setLoaded(true); };
    return (_jsxs(_Fragment, { children: [!loaded && skeleton && (_jsx(Skeleton, { variant: "rectangular", width: width, height: height, animation: "wave" })), _jsx("img", __assign({ src: src, alt: alt, width: width, height: height, onLoad: handleLoad }, rest))] }));
};
